// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Heading, SectionContainer } from '@shared/ui-kit/components';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

interface AssetProfileKeyStatisticsProps {
  statisticsProperties: {
    section: string;
    isVisible: boolean;
    properties: {
      label: string;
      value: any;
    }[];
  }[];
}

export const AssetProfileKeyStatistics: FC<AssetProfileKeyStatisticsProps> = ({
  statisticsProperties,
}) => {
  const { t } = useTranslation();
  return (
    <SectionContainer
      title={t('glossary.key-statistics', { ns: 'glossary' })}
      testId="statistics"
      className="!p-4"
      headerClass="!uppercase"
    >
      <div className="mt-4 grid grid-cols-[repeat(auto-fit,_minmax(100px,_1fr))] gap-8">
        {statisticsProperties.map((column, index) => (
          <div key={`${column.section}-${index}`} data-testid="statistics-column">
            <Heading
              key={`${column.section}-${index}-heading`}
              title={column.section}
              variant="h5"
              className="pb-4 !font-normal !text-border-dark"
            />
            <dl key={`${column.section}-${index}-list`} className="grid gap-4">
              {column.properties.map(property => (
                <div key={property.label}>
                  <dt>
                    <Heading title={property.label} variant="h5" />
                  </dt>
                  <dd className="!money-display">{property.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </SectionContainer>
  );
};
